// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WxVvfU0GpZ0Oc3HS9Y6f{justify-content:space-between;align-items:center;padding:0 20px;display:flex}.WxVvfU0GpZ0Oc3HS9Y6f:not(:last-child){margin-bottom:8px}.I8tBilj1grdsGv_TJNHw{background-color:var(--black-10);border-radius:6px;justify-content:center;align-items:center;width:32px;height:32px;margin-right:12px;display:flex}.vMYGf5_JeKkZEG74I5wu{width:100%;display:flex}.FHgkXGsce84MUgtv1MRB{align-items:center;gap:4px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"collapseWithIcon": `WxVvfU0GpZ0Oc3HS9Y6f`,
	"iconWrapper": `I8tBilj1grdsGv_TJNHw`,
	"doubleOptInSettingLayout": `vMYGf5_JeKkZEG74I5wu`,
	"autoCreateConversationsTitle": `FHgkXGsce84MUgtv1MRB`
};
export default ___CSS_LOADER_EXPORT___;
